import { Button, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Link } from 'react-router-dom'
import { useGetAccountAction } from 'modules/Services/hooks/useGetAccountAction'

export const MainActionButton = ({ main_action = null, i18n, id, className = '', type }) => {
  const pathGen = useGeneratePathI18n()
  if (!main_action) {
    return null
  }
  const { t } = useTranslation(['services'])
  const config = useGetAccountAction(main_action)

  const buttonProps = useMemo(() => {
    if (!config) return undefined

    const url = pathGen(config.url, {
      i18n,
      accountId: id,
      networkType: type,
    })

    switch (main_action) {
      case 'deposit':
        return {
          to: url,
          startIcon: 'card',
          component: Link,
        }

      case 'refresh':
        return {
          href: url,
          startIcon: 'refresh',
          component: 'a',
        }

      case 'deposit_creation_fee':
        return {
          to: url,
          startIcon: 'card',
          component: Link,
        }
    }
  }, [main_action])

  if (!buttonProps) {
    return null
  }

  const { startIcon, ...rest } = buttonProps

  return (
    <Button
      size="s"
      variant={'primary'}
      className={className}
      startIcon={<Icon name={startIcon} />}
      {...rest}
    >
      {t('services::account_list.actions.' + main_action)}
    </Button>
  )
}

MainActionButton.propTypes = {
  main_action: PropTypes.oneOf(['deposit', 'refresh', 'deposit_creation_fee']),
  i18n: PropTypes.string,
  id: PropTypes.number,
  type: PropTypes.string,
  className: PropTypes.string,
}
